import { useQuery } from '@tanstack/react-query';
import { getMyMotivationFacts } from '../lib/motivation';

export const motivationKeys = {
  all: ['motivation'] as const,
  mine: () => [...motivationKeys.all, 'mine'] as const,
};

export function useMyMotivationFacts(enabled: boolean) {
  return useQuery({
    queryKey: motivationKeys.mine(),
    queryFn: getMyMotivationFacts,
    enabled,
    staleTime: 60_000,
    retry: false,
  });
}
